import dropdownIcon from './dropdown.svg';
import emptyIcon from './empty.svg';
import errorIcon from './error.svg';
import eyeSlashIcon from './eye-slash.svg';
import eyeIcon from './eye.svg';
import merchantAddLinear from './merchant/add-linear.svg';
import merchantAddPrimary from './merchant/add-primary.svg';
import merchantAdd from './merchant/add.svg';
import merchantArrowDown from './merchant/arrow-down.svg';
import merchantArrowLeftDanger from './merchant/arrow-left-danger.svg';
import merchantArrowLeft from './merchant/arrow-left.svg';
import merchantArrowRight from './merchant/arrow-right.svg';
import merchantArrowUpDown from './merchant/arrow-up-down.svg';
import merchantBackIcon from './merchant/backIcon.svg';
import merchantBillingCredits from './merchant/billing-credits.svg';
import merchantBillingExternal from './merchant/billing-external.svg';
import merchantBlueskySocial from './merchant/bluesky-social.svg';
import merchantBookActive from './merchant/book-active.svg';
import merchantBook from './merchant/book.svg';
import merchantCalendarSlate from './merchant/calendar-slate.svg';
import merchantCalendar from './merchant/calendar.svg';
import merchantCardSim from './merchant/card-sim.svg';
import merchantChatPlus from './merchant/chat-plus.svg';
import merchantChevronDown from './merchant/chevron-down.svg';
import merchantChevronRight from './merchant/chevron-right.svg';
import merchantClockBoldSlate from './merchant/clock-bold-slate.svg';
import merchantClockBold from './merchant/clock-bold.svg';
import merchantClock from './merchant/clock.svg';
import merchantCloseCircle from './merchant/close-circle.svg';
import merchantCloudPlus from './merchant/cloud-plus.svg';
import merchantCloudPlus2 from './merchant/cloud-plus2.svg';
import merchantCloudUpload from './merchant/cloud-upload.svg';
import merchantConfigureIcon from './merchant/configureIcon.svg';
import merchantDiscountShapeActive from './merchant/discount-shape-active.svg';
import merchantDiscountShape from './merchant/discount-shape.svg';
import merchantDocumentActive from './merchant/document-active.svg';
import merchantDocumentText from './merchant/document-text.svg';
import merchantDocumentUpload from './merchant/document-upload.svg';
import merchantDocument from './merchant/document.svg';
import merchantDollarCircle from './merchant/dollar-circle.svg';
import merchantDownloadIcon from './merchant/downloadIcon.svg';
import merchantEdit2Bold from './merchant/edit-2-bold.svg';
import merchantEdit2 from './merchant/edit-2-con.svg';
import merchantElement3Active from './merchant/element-3-active.svg';
import merchantElement3 from './merchant/element-3.svg';
import merchantEye from './merchant/eye.svg';
import merchantFacebookSocial from './merchant/facebook-social.svg';
import merchantFeedAddCircle from './merchant/feed-add-circle.svg';
import merchantFeedCloseCircle from './merchant/feed-close-circle.svg';
import merchantFeedCopyActive from './merchant/feed-copy-active.svg';
import merchantFeedCopy from './merchant/feed-copy.svg';
import merchantFeedCreatePostUpload from './merchant/feed-create-post-upload.svg';
import merchantFeedEmojiHappy from './merchant/feed-emoji-happy.svg';
import merchantFeedGallery from './merchant/feed-gallery.svg';
import merchantFeedMaximize3Active from './merchant/feed-maximize-3-active.svg';
import merchantFeedMaximize3 from './merchant/feed-maximize-3.svg';
import merchantFilterAdd from './merchant/filter-add.svg';
import merchantFilterCloseCircle from './merchant/filter-close-circle.svg';
import merchantFollowerDetailBack from './merchant/follower-detail-back.svg';
import merchantGalleryActive from './merchant/gallery-active.svg';
import merchantGalleryMediaImage from './merchant/gallery-media-image.svg';
import merchantGalleryMediaVideo from './merchant/gallery-media-video.svg';
import merchantGallery from './merchant/gallery.svg';
import merchantGbp from './merchant/gbp-social.svg';
import merchantHeartLiked from './merchant/heart-liked.svg';
import merchantHeartOutline from './merchant/heart-outline.svg';
import merchantHeart from './merchant/heart.svg';
import merchantHome from './merchant/home.svg';
import merchantHomeOutline from './merchant/homeOutlineIcon.svg';
import merchantImagePlaceholder from './merchant/image-placeholder.svg';
import merchantImport from './merchant/import.svg';
import merchantInstagramSocial from './merchant/instagram-social.svg';
import launchpadIconFill from './merchant/launchPadIconFill.svg';
import launchpadIcon from './merchant/launchpadIcon.svg';
import merchantLink from './merchant/link.svg';
import merchantLinkedinSocial from './merchant/linkedin-social.svg';
import merchantLocationPin from './merchant/location-pin.svg';
import merchantLocation from './merchant/location.svg';
import merchantLogout from './merchant/logout.svg';
import merchantMagicpenBold from './merchant/magicpen-bold.svg';
import merchantMessengerOutline from './merchant/messenger-outline.svg';
import merchantMessenger from './merchant/messenger.svg';
import merchantMinusPrimary from './merchant/minus-primary.svg';
import merchantMoreVertical from './merchant/more-vertical.svg';
import merchantMore from './merchant/more.svg';
import merchantNotification from './merchant/notification.svg';
import merchantNotification2 from './merchant/notification2.svg';
import merchantNudgeAiBtnBg from './merchant/nudge-ai-btn-bg.png';
import merchantNudgeListPlay from './merchant/nudge-list-play.svg';
import merchantNudgePreviewLocation from './merchant/nudge-preview-location.svg';
import merchantNudgePreviewPrice from './merchant/nudge-preview-price.svg';
import merchantNudgePreviewReservations from './merchant/nudge-preview-reservations.svg';
import merchantPendingStatus from './merchant/pendingStatusIcon.svg';
import merchantPinterestSocial from './merchant/pinterest-social.svg';
import merchantPlanBadge from './merchant/plan-badge.svg';
import merchantPlanDollarCircle from './merchant/plan-dollar-circle.png';
import merchantPlus from './merchant/plus.svg';
import merchantPrefBudget from './merchant/preferences/pref-budget.png';
import merchantPrefCuisines from './merchant/preferences/pref-cuisines.png';
import merchantPrefDiningStyle from './merchant/preferences/pref-dining-style.png';
import merchantPrefEventTypes from './merchant/preferences/pref-event-types.png';
import merchantPrefNudges from './merchant/preferences/pref-nudges.png';
import merchantPrefRegions from './merchant/preferences/pref-regions.png';
import merchantPrefVibe from './merchant/preferences/pref-vibe.png';
import merchantPrefWineStyles from './merchant/preferences/pref-wine-styles.png';
import merchantPreviewArrowLeft from './merchant/preview-arrow-left.svg';
import merchantPreview from './merchant/preview.svg';
import merchantProfile2UserActive from './merchant/profile-2user-active.svg';
import merchantProfile2UserBold from './merchant/profile-2user-bold.svg';
import merchantProfile2User from './merchant/profile-2user.svg';
import merchantProfile from './merchant/profile.svg';
import merchantProfilePlaceHolderImage from './merchant/profilePlaceHolderImage.svg';
import merchantRefresh2 from './merchant/refresh-2.svg';
import merchantResourceIcon from './merchant/resourceIcon.svg';
import merchantScanBarcode from './merchant/scan-barcode.svg';
import merchantSearchNormal from './merchant/search-normal.svg';
import merchantSend2Linear from './merchant/send-2.svg';
import merchantSend3 from './merchant/send-3.svg';
import merchantSend2 from './merchant/send.svg';
import merchantSms from './merchant/sms.svg';
import merchantStar from './merchant/star.svg';
import merchantTag from './merchant/tag.svg';
import merchantThreadsSocial from './merchant/threads-social.svg';
import merchantTickCircle from './merchant/tick-circle.svg';
import merchantTickSquare from './merchant/tick-square.svg';
import merchantTick from './merchant/tick.svg';
import merchantTiktokSocial from './merchant/tiktok-social.svg';
import merchantToolsActive from './merchant/tools-active.svg';
import merchantToolsConfigure from './merchant/tools-configure.svg';
import merchantTools from './merchant/tools.svg';
import merchantTrashBold from './merchant/trash-bold.svg';
import merchantTrashLinear from './merchant/trash-linear.svg';
import merchantTrash from './merchant/trash.svg';
import merchantUserBold from './merchant/user-bold.svg';
import merchantUser from './merchant/user.svg';
import merchantVerify from './merchant/verify.svg';
import merchantVideoPlayBadge from './merchant/video-play-badge.png';
import merchantVideoPlayOutline from './merchant/video-play-outline.svg';
import merchantVideoPlay from './merchant/video-play.svg';
import merchantVideoReel from './merchant/video-reel.svg';
import merchantXCircle from './merchant/x-circle.svg';
import merchantYoutubeSocial from './merchant/youtube-social.svg';
import searchIcon from './search.svg';
import successIcon from './success.svg';
import uploadIcon from './upload.svg';
import userIcon from './user.svg';
import warningIcon from './warning.svg';

export const icons = {
  empty: emptyIcon,
  error: errorIcon,
  eye: eyeIcon,
  eyeSlash: eyeSlashIcon,
  success: successIcon,
  warning: warningIcon,
  upload: uploadIcon,
  user: userIcon,
  search: searchIcon,
  dropdown: dropdownIcon,
};

export const merchantIcons = {
  add: merchantAdd,
  addLinear: merchantAddLinear,
  addPrimary: merchantAddPrimary,
  arrowDown: merchantArrowDown,
  arrowLeftDanger: merchantArrowLeftDanger,
  arrowLeft: merchantArrowLeft,
  arrowRight: merchantArrowRight,
  arrowUpDown: merchantArrowUpDown,
  calendar: merchantCalendar,
  calendarSlate: merchantCalendarSlate,
  cardSim: merchantCardSim,
  chatPlus: merchantChatPlus,
  chevronDown: merchantChevronDown,
  chevronRight: merchantChevronRight,
  closeCircle: merchantCloseCircle,
  backIcon: merchantBackIcon,
  billingCredits: merchantBillingCredits,
  billingExternal: merchantBillingExternal,
  cloudPlus: merchantCloudPlus,
  cloudUpload: merchantCloudUpload,
  nudgeAiBtnBg: merchantNudgeAiBtnBg,
  cloudPlus2: merchantCloudPlus2,
  xCircle: merchantXCircle,
  clock: merchantClock,
  clockBold: merchantClockBold,
  clockBoldSlate: merchantClockBoldSlate,
  book: merchantBook,
  bookActive: merchantBookActive,
  discountShape: merchantDiscountShape,
  discountShapeActive: merchantDiscountShapeActive,
  resourceIcon: merchantResourceIcon,
  document: merchantDocument,
  documentActive: merchantDocumentActive,
  documentText: merchantDocumentText,
  documentUpload: merchantDocumentUpload,
  blueskySocial: merchantBlueskySocial,
  facebookSocial: merchantFacebookSocial,
  gbp: merchantGbp,
  feedAddCircle: merchantFeedAddCircle,
  feedCloseCircle: merchantFeedCloseCircle,
  feedCreatePostUpload: merchantFeedCreatePostUpload,
  feedCopy: merchantFeedCopy,
  feedCopyActive: merchantFeedCopyActive,
  feedEmojiHappy: merchantFeedEmojiHappy,
  feedGallery: merchantFeedGallery,
  feedMaximize3: merchantFeedMaximize3,
  feedMaximize3Active: merchantFeedMaximize3Active,
  followerDetailBack: merchantFollowerDetailBack,
  filterAdd: merchantFilterAdd,
  filterCloseCircle: merchantFilterCloseCircle,
  gallery: merchantGallery,
  galleryActive: merchantGalleryActive,
  galleryMediaImage: merchantGalleryMediaImage,
  galleryMediaVideo: merchantGalleryMediaVideo,
  dollarCircle: merchantDollarCircle,
  edit2: merchantEdit2,
  edit2Bold: merchantEdit2Bold,
  eye: merchantEye,
  preview: merchantPreview,
  previewArrowLeft: merchantPreviewArrowLeft,
  element3: merchantElement3,
  element3Active: merchantElement3Active,
  heart: merchantHeart,
  heartLiked: merchantHeartLiked,
  heartOutline: merchantHeartOutline,
  home: merchantHome,
  homeOutline: merchantHomeOutline,
  homeOutlineIcon: merchantHomeOutline,
  download: merchantImport,
  downloadIcon: merchantDownloadIcon,
  instagramSocial: merchantInstagramSocial,
  linkedinSocial: merchantLinkedinSocial,
  link: merchantLink,
  location: merchantLocation,
  locationPin: merchantLocationPin,
  messenger: merchantMessenger,
  messengerOutline: merchantMessengerOutline,
  minusPrimary: merchantMinusPrimary,
  more: merchantMore,
  moreVertical: merchantMoreVertical,
  notification: merchantNotification,
  notification2: merchantNotification2,
  nudgePreviewLocation: merchantNudgePreviewLocation,
  nudgePreviewPrice: merchantNudgePreviewPrice,
  nudgePreviewReservations: merchantNudgePreviewReservations,
  pendingStatus: merchantPendingStatus,
  pinterestSocial: merchantPinterestSocial,
  plus: merchantPlus,
  prefBudget: merchantPrefBudget,
  prefCuisines: merchantPrefCuisines,
  prefDiningStyle: merchantPrefDiningStyle,
  prefEventTypes: merchantPrefEventTypes,
  prefNudges: merchantPrefNudges,
  prefRegions: merchantPrefRegions,
  prefVibe: merchantPrefVibe,
  prefWineStyles: merchantPrefWineStyles,
  profile: merchantProfile,
  profile2User: merchantProfile2User,
  profile2UserActive: merchantProfile2UserActive,
  profile2UserBold: merchantProfile2UserBold,
  profilePlaceHolderImage: merchantProfilePlaceHolderImage,
  imagePlaceholder: merchantImagePlaceholder,
  logout: merchantLogout,
  magicpenBold: merchantMagicpenBold,
  refresh2: merchantRefresh2,
  scanBarcode: merchantScanBarcode,
  searchNormal: merchantSearchNormal,
  send2: merchantSend2,
  send2Linear: merchantSend2Linear,
  send3: merchantSend3,
  sms: merchantSms,
  star: merchantStar,
  tag: merchantTag,
  threadsSocial: merchantThreadsSocial,
  tiktokSocial: merchantTiktokSocial,
  planBadge: merchantPlanBadge,
  planDollarCircle: merchantPlanDollarCircle,
  tick: merchantTick,
  tickCircle: merchantTickCircle,
  tickSquare: merchantTickSquare,
  trash: merchantTrash,
  trashBold: merchantTrashBold,
  trashLinear: merchantTrashLinear,
  user: merchantUser,
  userBold: merchantUserBold,
  verify: merchantVerify,
  videoPlay: merchantVideoPlay,
  videoPlayBadge: merchantVideoPlayBadge,
  videoReel: merchantVideoReel,
  videoPlayOutline: merchantVideoPlayOutline,
  nudgeListPlay: merchantNudgeListPlay,
  youtubeSocial: merchantYoutubeSocial,
  tools: merchantToolsActive,
  toolsInactive: merchantTools,
  toolsConfigure: merchantToolsConfigure,
  launchpadIcon: launchpadIcon,
  launchpadIconFill: launchpadIconFill,
  configureIcon: merchantConfigureIcon,
};

export default icons;
